// extracted by mini-css-extract-plugin
export default {"nhima-header":"Header_nhima-header__UA9tJ","nhima-header__buttons":"Header_nhima-header__buttons__p0K+f"};